/** Remove drafts saved by the former persistent-preview implementation. Never read their contents. */
export function clearLegacyRejectedFeePreviews(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith("asset:rejected-fee-preview:")) localStorage.removeItem(key);
    }
  } catch {
    // Browser storage may be disabled; startup and sign-out must still work.
  }
}
